import { logger } from '../../logger';
import { instantiateWasm } from '../../wasm';
const log = logger('Encryption');

let ready = null;
const isSupported = typeof WebAssembly !== 'undefined';

export default function () {
  const mod = {
    exports: null,
    onload: onload,
    status: isSupported ? 'uninitialized' : 'unsupported'
  };

  if (isSupported && !mod.exports) {
    if (!ready) {
      log.info('Loading XSALSA20 .wasm file from public');
      mod.status = 'loading';
      ready = fetch('/scripts/wasm/xsalsa20.wasm')
        .then(instantiateWasm)
        .then(w => {
          mod.exports = w.instance.exports;
          mod.status = 'ready';
          log.info('XSALSA20 WASM module loaded');
          return w.instance;
        })
        .catch(err => {
          log.warn('Error loading XSALSA20 WASM module', err);
          mod.status = 'error';
        });
    }
  }

  return mod;
}
